/* (c) 2020-2023, Nextwave Logic, Inc. All Rights Reserved */

import React, { useContext } from 'react';
import { Route, Redirect } from 'react-router-dom';


// local imports
import { AuthContext } from '../contexts/AuthContext';


const PrivateRoute = ({ component: Component, roles, ...rest }) => {
    const { isAuthenticated, user } = useContext(AuthContext);
    return (
        <Route {...rest} render={props => {
            if (!isAuthenticated)
                return <Redirect to={{
                    pathname: '/user/signin',
                    state: { from: props.location }
                }} />

            if (!roles.includes(user.selectedRole))
                return <Redirect to={{
                    pathname: '/',
                    state: { from: props.location }
                }} />

            return <Component {...props} />

        }} />
    )
}

export default PrivateRoute;